const educations = [
    {
        id: 1,
        degree: "Digital Egypt Pioneers Initiative",
        details: "Data Analysis Specialist | Jul 2025 - Dec 2025",
        subjects: [
            {
                title: "Data Analysis",
                description: "Understanding, cleaning, and transforming data to extract meaningful insights and trends."
            },
            {
                title: "Data Visualization",
                description: "Presenting data clearly through charts, dashboards, and visuals using Power BI and Tableau."
            },
            {
                title: "Statistical Analysis",
                description: "Applying descriptive and inferential statistics to interpret datasets effectively."
            },
            {
                title: "Data-Driven Decision Making",
                description: "Using data insights to guide strategic and business-oriented decisions."
            },
            {
                title: "Tools: Excel, Power BI, Tableau",
                description: "Hands-on experience with leading data analysis and visualization tools."
            },
            {
                title: "Project: Data Analysis Capstone",
                description: "Conducted a comprehensive end-to-end project using real-world data."
            }
        ]
    },
    {
        id: 2,
        degree: "Bachelor of Computing and Artificial Intelligence, Cairo University",
        details: "Information Systems Department | Grade: Very Good | 2021 - 2025",
        subjects: [
            {
                title: "Data Structures and Algorithms",
                description: "Studied core programming logic and efficient problem-solving techniques."
            },
            {
                title: "Database Management Systems",
                description: "Designed and managed relational databases using SQL and normalization principles."
            },
            {
                title: "Web Development",
                description: "Built interactive and responsive web applications using HTML, CSS, JavaScript, and frameworks."
            },
            {
                title: "Artificial Intelligence",
                description: "Learned about intelligent systems, search algorithms, and AI problem-solving approaches."
            },
            {
                title: "Machine Learning",
                description: "Applied supervised and unsupervised learning models to analyze and predict data patterns."
            },
            {
                title: "Computer Networks",
                description: "Explored network architectures, protocols, and data communication fundamentals."
            },
            {
                title: "Software Engineering",
                description: "Applied software design patterns, SDLC, and project management practices."
            },
            {
                title: "Operating Systems",
                description: "Understood OS architecture, process management, and memory handling concepts."
            },
            {
                title: "Mobile Application Development",
                description: "Developed cross-platform applications integrating APIs and UI/UX best practices."
            }
        ]
    }
];

export const getEducationsData = () => {
    return educations;
};
